import "./index.css";
import React, { Fragment } from "react";
import ReactDOM from "react-dom/client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Global } from "@emotion/react";
import AppRoutes from "./Routes";
import { BrowserRouter } from "react-router-dom";
import { Box, ChakraProvider } from "@chakra-ui/react";
import { GlobalStyles } from "./constants/globalStyles";
import { UserInfoProvider } from "./context/UserInfo";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const queryClient = new QueryClient();

root.render(
  <ChakraProvider>
    <Global styles={GlobalStyles} />
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <UserInfoProvider>
          <AppRoutes></AppRoutes>
        </UserInfoProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </ChakraProvider>
);
